import Marquee from "react-fast-marquee";

const items = ["TAHA DEVELOPERS", "WHERE DREAMS BECOME REALITY", "DAHOD — GUJARAT", "BUILDING LEGACIES"];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-[#C5A059]/20 py-6 bg-black overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={25} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-32 mr-32">
            <span className="font-display text-sm sm:text-base tracking-[0.25em] uppercase text-[#C5A059]/80 whitespace-nowrap">{item}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#C5A059]/50 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
